import Api from '@/services/Api'

// Razmjena s POS kasom. Kasa radi na svom racunalu ili android uredaju, pa
// racune SALJE ona, a sifrarnik s cijenama povlaci sa servera (SQL A10).
export default {
  // Racuni s kase na server. {CompanyId, BusinessYear, odDatuma, doDatuma,
  // sklad, samoPregled}
  posalji (dokument) {
    return Api().post('razmjena/pos/posalji', dokument)
  },
  // Artikli i grupe s cijenama sa servera na kasu. {CompanyId, samoPregled}
  osvjezi (dokument) {
    return Api().post('razmjena/pos/osvjezi', dokument)
  }
}
